// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2LOHn","col":"styles_col__beHXo","fulfillmentStatus":"styles_fulfillmentStatus__22H8H","emailCol":"styles_emailCol__1Ja5-"};